var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 873.1 192.8",
    style: {
      enableBackground: "new 0 0 873.1 192.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 235.3,
    y: 4.5,
    className: "st0",
    width: 45.6,
    height: 164.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M704.1,27.2C664.8,27.2,633,59,633,98.3c0,39.3,31.9,71.2,71.2,71.2c31.3,0,57.8-20.2,67.4-48.2h-44.6 c-5.8,5.8-13.9,9.4-22.8,9.4c-13.6,0-25.2-8.4-30-20.2c0,0,60,0,59.9,0.1h40.1c0.7-4,1.1-8,1.1-12.2 C775.3,59,743.4,27.2,704.1,27.2z M674.8,84.6c5.2-11,16.3-18.6,29.3-18.6c13,0,24.1,7.6,29.3,18.6H674.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M871.3,66V30.2h-28.5V4.3h-45.1V115c0,30,24.4,54.3,54.3,54.3h19.3v-45.1H852c-5.1,0-9.2-4.1-9.2-9.2V66H871.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M370.5,27.2c-39.3,0-71.2,31.9-71.2,71.2c0,39.3,31.9,71.2,71.2,71.2c9.6,0,18.8-1.9,27.2-5.4v5.4h44V98.3 C441.7,59,409.8,27.2,370.5,27.2z M370.5,130.7c-17.9,0-32.3-14.5-32.3-32.3c0-17.9,14.5-32.3,32.3-32.3s32.3,14.5,32.3,32.3 C402.8,116.2,388.4,130.7,370.5,130.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.7,27.2c-39.3,0-71.2,31.9-71.2,71.2v93.8h44v-28c8.4,3.5,17.6,5.4,27.2,5.4c39.3,0,71.2-31.9,71.2-71.2 C216.8,59,185,27.2,145.7,27.2z M145.7,130.7c-17.9,0-32.3-14.5-32.3-32.3c0-17.9,14.5-32.3,32.3-32.3c17.9,0,32.3,14.5,32.3,32.3 C178,116.2,163.5,130.7,145.7,130.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M539.8,27.2c-39.3,0-71.2,31.9-71.2,71.2v71.2h45.6V96.7c0-14.1,11.4-25.5,25.5-25.5 c14.1,0,25.5,11.4,25.5,25.5v72.8H611V98.3C611,59,579.1,27.2,539.8,27.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3827 -0.9239 0.9239 0.3827 -9.4263 51.826)",
    className: "st0",
    cx: 34.1,
    cy: 33,
    rx: 32.3,
    ry: 32.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanet);
export default __webpack_public_path__ + "static/media/planet.fefc64acd6733d3552f8f30f8bad3f0b.svg";
export { ForwardRef as ReactComponent };